import { Component, OnInit } from '@angular/core';
import { MasterService } from 'src/app/services/master/master.service';
import { AlertService } from "../../../../_services/alert.service";
import { ClientService } from 'src/app/services/clients/client.service';
import { FormControl, FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { CbService } from 'src/app/services/contentbuilder/contentbuilder.service';

@Component({
  selector: 'app-add-content-builder-fields',
  templateUrl: './add-content-builder-fields.component.html',
  styleUrls: ['./add-content-builder-fields.component.css']
})
export class AddContentBuilderFieldsComponent extends BaseComponent implements OnInit {
  name;
  description;
  screenshot: String;
  IsActive;
  id;
  themObj;
  imageCropData;
  imgButtonText;
  fileData;
  fileUploaded;
  imageSrc;
  them_awskey;
  them_company;
  getCompanyobj:any=[];
  theme_screenshot;
  status: boolean = true;
  screenshot_type = true;
  headers = "Add";
  companyID;

  submitted = false;
  templateForm: FormGroup;
  getSectionobj:any=[];
  controlEnabled:boolean = true;
  constructor(
    private master: MasterService,
    private clientService: ClientService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private cb: CbService,
  ) { 
    super();
  }

  ngOnInit() {
    let self = this;
    self.getCompany();
   // self.getTemplateSection(this.id);
   this.controlEnabled = true;
    this.activatedRoute.queryParams
      .subscribe(params => {
        this.id = params.id;
        this.companyID = params.companyID;

      });
    if (this.id) {
      this.UpdateTemplateLogData()
    }
    else {
      this.addTemplateLogData()
    }
    //get item details using id
    if (this.id) {
      this.ngxSpinnerService.show();
      this.headers = "Edit"
      this.cb.getFieldById(this.companyID,this.id).subscribe(response => {
       
        if (response.status) {
          this.status = false;
          self.themObj = response.data;
          this.ngxSpinnerService.hide();
            self.dataBinding();
        } else {
        }
      });
    }
    this.templateForm = this.formBuilder.group({
      company: ['', Validators.required],
      field_name: ['', Validators.required],     
      field_type: ['', Validators.required],
      isrequire:[false],
      field_description: [''],
     
     
    });
  }
  get f() { return this.templateForm.controls; }

 

  addField() {
    this.submitted = true;
  

    if (this.templateForm.invalid) {
      return;
    }
    let { company, field_name, field_description,field_type,isrequire } = this.templateForm.value;
    
    let themeObj = {
      field_name: field_name,
      field_description: field_description,
      isrequire:isrequire || false,      
      field_type: field_type,
      isactive: true,
      company: company
    }
  
    this.ngxSpinnerService.show();
   // console.log('sssss');
    this.cb.addingField(themeObj).subscribe(data => {
    //  console.log(data);
      if (data.status) {
        this.toastrService.success("Added Successfully")
        this.router.navigateByUrl(`/corporate/content-builder-field`);
        this.ngxSpinnerService.hide();
      } else { 
        this.toastrService.error(data.message)
        this.ngxSpinnerService.hide();
      }
      
    }, error => {
    //  console.log(error);
      this.ngxSpinnerService.hide();
    });

  }
  addTemplateLogData() {
    let themeLogs = {
      log_type: "Adding New Template",
      log_name: "Adding New Template",
      log_description: "Adding New Template",
      moduleid: 1,
      moduleitemid: 7,
      per_id: 14
    }
    this.logs.addNewLogs(themeLogs).subscribe(data => {
     // console.log(data);
    }, error => {
    //  console.log(error);
    });
  }
  UpdateTemplateLogData() {
    let themeLogs = {
      log_type: "Updating Template Data",
      log_name: "Updating Template Data",
      log_description: "Updating Template Data",
      moduleid: 1,
      moduleitemid: 7,
      per_id: 14
    }
    this.logs.addNewLogs(themeLogs).subscribe(data => {
    //  console.log(data);
    }, error => {
     // console.log(error);
    });
  }
  dataBinding() {
 // console.log("data binidning...."+this.themObj.name)
    
   
   
      this.templateForm = this.formBuilder.group({
        company: [this.companyID.toString(), Validators.required],
        field_name: [this.themObj.field_name, Validators.required],
        field_description: [this.themObj.field_description],       
        field_type: [this.themObj.field_type, Validators.required],
        isrequire:[this.themObj.isrequire]
      });
    
  }
  getCompany() {
    let self = this;
    this.clientService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      self.hydrateWorkingCompany(self);

    //  console.log(self.getCompanyobj);
    }, error => {
    //  console.log(error);
    });
  }
  updateField() {
    this.submitted = true;
    if (this.templateForm.invalid) {
      return;
    }
    let { company, field_name, field_description, field_type,isrequire } = this.templateForm.value;
    
    let themobj = {
      field_name: field_name,
      field_description: field_description,
      isrequire:isrequire,     
      field_type: field_type,     
      fieldid: Number.parseInt(this.id, 10),
      company: company
    }
  //  console.log('themobj', themobj);
    this.ngxSpinnerService.show();
    this.cb.UpdateField(themobj).subscribe(data => {
      if (data.status) {
        this.toastrService.success(" Updated Successfully")
        this.router.navigateByUrl(`/corporate/content-builder-field`);
        this.ngxSpinnerService.hide();
      }
    }, error => {
      console.error(error);
      this.ngxSpinnerService.hide();
    });
  }
  
 
}